"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Strings_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.words = exports.truncateString = exports.titleCase = exports.stringToArray = exports.snakeCase = exports.reverseString = exports.removeWhitespace = exports.plural = exports.pascalCase = exports.padString = exports.occurrences = exports.kebabCase = exports.isTruthy = exports.isNumber = exports.isFalsy = exports.capitalize = exports.camelCase = exports.Strings = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
let Strings = Strings_1 = class Strings {
    static camelCase(text) {
        text = Strings_1.pascalCase(text);
        return text.charAt(0).toLowerCase() + text.slice(1);
    }
    static capitalize(text) {
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
    static isFalsy(text, additionalFalsyValues = []) {
        const defaultFalsyValues = ['', '0', 'false', 'no', 'nil', 'none', 'n/a', 'undefined', 'null', 'off'];
        const falsyValues = [...defaultFalsyValues, ...additionalFalsyValues.map((v) => v.toLowerCase())];
        return falsyValues.includes(text.trim().toLowerCase());
    }
    static isNumber(text) {
        return !isNaN(parseFloat(text)) && isFinite(Number(text));
    }
    static isTruthy(text) {
        return !Strings_1.isFalsy(text);
    }
    static kebabCase(text, splitCase = false) {
        text = text.trim();
        if (splitCase) {
            text = text.replace(/([a-z])([A-Z])/g, '$1 $2');
            text = text.replace(/([a-zA-Z])([0-9])/g, '$1 $2').replace(/([0-9])([a-zA-Z])/g, '$1 $2');
        }
        text = text.replace(/[^a-zA-Z0-9\s-]/g, ' ').replace(/\s+/g, '-');
        text = text.replace(/^-+|-+$/g, '').replace(/-{2,}/g, '-');
        return text.toLowerCase();
    }
    static occurrences(text, substring) {
        return text.split(substring).length - 1;
    }
    static padString(text, length, char = ' ') {
        if (text.length >= length)
            return text;
        const padLength = length - text.length;
        return text + char.repeat(padLength);
    }
    static pascalCase(text) {
        return Strings_1.removeWhitespace(Strings_1.titleCase(text));
    }
    static plural(word, number) {
        return number === 1 ? word : `${word}s`;
    }
    static removeWhitespace(text) {
        return text.replace(/\s+/g, '');
    }
    static reverseString(text) {
        return text.split('').reverse().join('');
    }
    static snakeCase(text) {
        return text.toLowerCase().split(/\s+/).join('_');
    }
    static stringToArray(text, options) {
        let result = [];
        if (options?.removeWhitespace ?? true) {
            text = Strings_1.removeWhitespace(text);
        }
        if (text) {
            result = text.split(options?.delimiter ?? ',');
        }
        return result;
    }
    static titleCase(text, delimiter = /\s+/) {
        return text
            .split(delimiter)
            .map((word) => Strings_1.capitalize(word))
            .join(' ');
    }
    static truncateString(text, length) {
        return text.length > length ? text.slice(0, length) + '...' : text;
    }
    static words(text) {
        return text.trim().split(/\s+/);
    }
};
exports.Strings = Strings;
exports.Strings = Strings = Strings_1 = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log)
], Strings);
exports.camelCase = Strings.camelCase, exports.capitalize = Strings.capitalize, exports.isFalsy = Strings.isFalsy, exports.isNumber = Strings.isNumber, exports.isTruthy = Strings.isTruthy, exports.kebabCase = Strings.kebabCase, exports.occurrences = Strings.occurrences, exports.padString = Strings.padString, exports.pascalCase = Strings.pascalCase, exports.plural = Strings.plural, exports.removeWhitespace = Strings.removeWhitespace, exports.reverseString = Strings.reverseString, exports.snakeCase = Strings.snakeCase, exports.stringToArray = Strings.stringToArray, exports.titleCase = Strings.titleCase, exports.truncateString = Strings.truncateString, exports.words = Strings.words;
//# sourceMappingURL=strings.js.map